module.exports = __webpack_public_path__ + "img/QR code.c9197a4e.png";